// (c) TwistedMinds, Gerry Uytdenhouwen - 2 november 2026

const DAY_MS = 24 * 60 * 60 * 1000;

// The API sends order dates as 'd-m-Y' (31-10-2026), which `new Date()` cannot parse.
// Dates are handled in UTC so a daylight-saving switch never shifts a day.
const parseDayMonthYear = (value) => {
    const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value || '');
    return match ? Date.UTC(Number(match[3]), Number(match[2]) - 1, Number(match[1])) : null;
};

const formatDayMonthYear = (timestamp) => {
    const date = new Date(timestamp);
    const pad = (number) => String(number).padStart(2, '0');
    return `${pad(date.getUTCDate())}-${pad(date.getUTCMonth() + 1)}-${date.getUTCFullYear()}`;
};

/**
 * Orders per day for the dashboard sparkline, with an empty day before and after
 * so a single day still draws a line.
 */
export const buildOrdersGraph = (dates) => {
    const countPerDay = new Map();
    dates.map(parseDayMonthYear)
        .filter((timestamp) => timestamp !== null)
        .forEach((timestamp) => countPerDay.set(timestamp, (countPerDay.get(timestamp) || 0) + 1));

    const days = [...countPerDay.keys()].sort((first, second) => first - second);
    if (days.length === 0) {
        return {labels: [], values: []};
    }

    const allDays = [days[0] - DAY_MS, ...days, days[days.length - 1] + DAY_MS];
    return {
        labels: allDays.map(formatDayMonthYear),
        values: allDays.map((timestamp) => countPerDay.get(timestamp) || 0),
    };
};
